import { Outlet } from 'react-router';

export const UserPageOutlet = function UserPageOutlet() {
  return <Outlet />;
};
